import { render } from "./NavPill.vue?vue&type=template&id=7aeea9bc"
import script from "./NavPill.vue?vue&type=script&lang=js"
export * from "./NavPill.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__